import { render, staticRenderFns } from "./CargoComponent.vue?vue&type=template&id=d4e905d0&"
import script from "./CargoComponent.vue?vue&type=script&lang=js&"
export * from "./CargoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports